let fonts = ['Pacifico, cursive', 'Lobster, cursive', 'Comfortaa, cursive', 'Russo One, sans-serif', 'Old Standard TT, serif', 'Caveat, cursive', 'Marck Script, cursive', 'Montserrat, sans-serif', 'Neucha, cursive'];
export default fonts;


// WEBPACK FOOTER //
// ./src/UI/Fonts/Fonts.js